import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {EMPTY, Observable, ReplaySubject} from 'rxjs';
import {switchMap, take, takeUntil, tap} from 'rxjs/operators';
import {PartnerFacility} from '../../../shared/interface/partner-facility';
import {ConfirmDialogComponent} from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FacilityService} from '../../../shared/services/facility.service';
import {Router} from '@angular/router';
import {UserApplicationPermission, UserPermissions} from '../../../shared/interface/user-permissions';
import {AuthService} from '../../../shared/services/auth.service';
import {Dictionary} from '../../../shared/interface/dictionary';
import {PARTNER_TAGS_GOOD_AGENT, PARTNER_TAGS_PROFIT} from '../../../shared/services/dict.service';
import {Partner} from '../../../shared/interface/partner';
import {HttpErrorResponse} from "@angular/common/http";
import {FacilityDobryAgent} from "../../../shared/interface/facility-dobry-agent";

@Component({
  selector: 'app-facility-details-view',
  templateUrl: './facility-details-view.component.html',
  styleUrls: ['./facility-details-view.component.scss']
})
export class FacilityDetailsViewComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  @Input() facility: Observable<PartnerFacility>;
  @Input() facilityDobryAgent: Observable<FacilityDobryAgent | null>;
  @Output() modifyClicked = new EventEmitter<any>();
  facilityObject?: PartnerFacility;
  facilityDobryAgentObject?: FacilityDobryAgent | null;
  userPermissions: ReplaySubject<UserPermissions>;
  profitFacility = false;
  userApplicationPermission: ReplaySubject<UserApplicationPermission>;
  loadingFacilityDobryAgent = true;
  constructor(
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private facilityService: FacilityService,
    private router: Router,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.userApplicationPermission = auth.getUserApplicationPermission();

  }

  ngOnInit(): void {
    this.facility
      .pipe(
        takeUntil(this.destroyed$),
        tap((facility: PartnerFacility) => {
          this.facilityObject = facility;
          this.profitFacility = this.hasPartnerTag(facility, PARTNER_TAGS_PROFIT);
        }),
      )
      .subscribe((res) => {
      });

    this.facilityDobryAgent
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe((facility: FacilityDobryAgent | null) => {
        this.facilityDobryAgentObject = facility;
        this.loadingFacilityDobryAgent = false;
      });
  }

  hasPartnerTag(facility: PartnerFacility, tagKey: string): boolean {
    if (!facility?.partners?.length) {
      return false;
    }

    return facility.partners.some((partner: Partner) => {
      return partner.tags?.some((tag: Dictionary) => tag.key === tagKey);
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }

  delete(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć placówkę?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.facilityService.deleteFacility(this.facilityObject.address.uuid)
          .subscribe({
            next: () => {
              this.snack.open('Pomyślnie usunięto placówkę', '', {duration: 2000});
              this.router.navigate(['/placowki']);
            },
            error: (response: HttpErrorResponse) => {
              this.snack.open(response.error.error.text, response.status.toString(), {duration: 2000});
            }
          });
      }
    });
  }
  readonly PARTNER_TAGS_GOOD_AGENT = PARTNER_TAGS_GOOD_AGENT;
}
